const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    backgroundColor: "white",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 57,
    px: 2,
    py: 1.75,
    borderBottom: "1px solid #f3f4f6",
    flexShrink: 0,
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    color: "#6a7282",
    fontSize: 12,
    fontWeight: 500,
    textTransform: "none",
    minWidth: 0,
    p: 0,
    "&:hover": {
      backgroundColor: "transparent",
      color: "#364153",
    },
  },
  backIcon: {
    fontSize: 13,
  },
  title: {
    fontSize: 12,
    fontWeight: 600,
    color: "#1e2939",
    lineHeight: "16px",
  },
  closeButton: {
    color: "#99a1af",
    borderRadius: "10px",
    width: 28,
    height: 28,
    "&:hover": {
      backgroundColor: "#f9fafb",
    },
  },
  closeIcon: {
    fontSize: 14,
  },
  body: {
    flex: 1,
    overflowY: "auto",
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  infoBox: {
    backgroundColor: "#f5faf7",
    border: "1px solid #d8eee2",
    borderRadius: "14px",
    p: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  infoTitle: {
    fontSize: 11,
    fontWeight: 600,
    color: "#364153",
    lineHeight: "16.5px",
  },
  infoRows: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  infoRow: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  exampleIcon: {
    width: 12,
    fontSize: 12,
    display: "flex",
    justifyContent: "center",
  },
  instagramIcon: {
    color: "#E4405F",
  },
  globeIcon: {
    color: "#3b82f6",
  },
  buildingIcon: {
    color: "#16a34a",
  },
  chip: {
    backgroundColor: "white",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    px: 1,
    py: "2px",
    fontFamily: "Menlo, monospace",
    fontSize: 11,
    color: "#364153",
    lineHeight: "16.5px",
  },
  exampleLabel: {
    fontSize: 11,
    color: "#99a1af",
    lineHeight: "16.5px",
  },
  infoFooter: {
    fontSize: 10,
    color: "#99a1af",
    lineHeight: "16.25px",
    "& .mono": {
      fontFamily: "Menlo, monospace",
    },
  },
  textarea: {
    backgroundColor: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "14px",
    p: "10px 12px",
    minHeight: 182,
    "& .MuiInputBase-root": {
      p: 0,
      fontFamily: "Menlo, monospace",
      fontSize: 12,
      color: "#364153",
      lineHeight: "16px",
      alignItems: "flex-start",
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#d1d5dc",
      opacity: 1,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  metaRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
  },
  issuesBox: {
    backgroundColor: "#fef2f2",
    border: "1px solid #fecaca",
    borderRadius: "14px",
    p: "12px 14px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  issuesTitle: {
    fontSize: 11,
    fontWeight: 600,
    color: "#b91c1c",
    lineHeight: "16.5px",
  },
  issueRow: {
    display: "flex",
    flexDirection: "column",
    gap: "3px",
    pl: "8px",
    borderLeft: "2px solid #fca5a5",
  },
  issueHeader: {
    display: "flex",
    alignItems: "baseline",
    gap: "6px",
    minWidth: 0,
  },
  issueLineNum: {
    flexShrink: 0,
    fontFamily: "Menlo, monospace",
    fontSize: 10,
    fontWeight: 600,
    color: "#b91c1c",
    lineHeight: "15px",
  },
  issueContent: {
    minWidth: 0,
    fontFamily: "Menlo, monospace",
    fontSize: 11,
    color: "#364153",
    lineHeight: "16px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  issueMessage: {
    fontSize: 10,
    color: "#991b1b",
    lineHeight: "15px",
  },
  issuesToggle: {
    all: "unset",
    alignSelf: "flex-start",
    fontSize: 10,
    fontWeight: 600,
    color: "#b91c1c",
    cursor: "pointer",
    textDecoration: "underline",
    textUnderlineOffset: "2px",
    "&:hover": {
      color: "#7f1d1d",
    },
  },
  attachButton: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    color: "#6a7282",
    fontSize: 12,
    fontWeight: 500,
    textTransform: "none",
    p: 0,
    alignSelf: "flex-start",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  countLabel: {
    fontSize: 11,
    color: "#99a1af",
    lineHeight: "16.5px",
  },
  attachIconWrapper: {
    width: 28,
    height: 28,
    borderRadius: "10px",
    backgroundColor: "white",
    border: "1px solid #e5e7eb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  attachIcon: {
    fontSize: 12,
    color: "#6a7282",
  },
  footer: {
    px: 2,
    pt: "13px",
    pb: 2,
    borderTop: "1px solid #f3f4f6",
    flexShrink: 0,
  },
  findBrandsButton: {
    width: "100%",
    height: 36,
    borderRadius: "14px",
    backgroundColor: "#1b4332",
    color: "white",
    fontSize: 12,
    fontWeight: 500,
    textTransform: "none",
    gap: 0.75,
    "&:hover": {
      backgroundColor: "#163528",
    },
    "&.Mui-disabled": {
      backgroundColor: "#1b4332",
      color: "white",
      opacity: 0.4,
    },
  },
  findBrandsIcon: {
    fontSize: 13,
  },
  loadingRoot: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    backgroundColor: "white",
  },
  loadingIconCircle: {
    width: 48,
    height: 48,
    borderRadius: "50%",
    backgroundColor: "#eaf5ee",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loadingSpinner: {
    width: 20,
    height: 20,
    borderRadius: "50%",
    border: "2.5px solid #1b4332",
    borderTopColor: "transparent",
    animation: "uploadBrandsSpin 0.8s linear infinite",
    "@keyframes uploadBrandsSpin": {
      from: { transform: "rotate(0deg)" },
      to: { transform: "rotate(360deg)" },
    },
  },
  loadingTitle: {
    mt: "16px",
    fontSize: 14,
    fontWeight: 600,
    color: "#1e2939",
    lineHeight: "20px",
    letterSpacing: "-0.15px",
  },
  loadingSubtitle: {
    mt: "4px",
    fontSize: 12,
    color: "#99a1af",
    lineHeight: "16px",
  },
  loadingBarTrack: {
    mt: "24px",
    width: 160,
    height: 4,
    borderRadius: "9999px",
    backgroundColor: "#f3f4f6",
    overflow: "hidden",
  },
  loadingBarFill: {
    height: "100%",
    width: "40%",
    borderRadius: "9999px",
    backgroundColor: "#1b4332",
    animation: "uploadBrandsProgress 1.4s ease-in-out infinite",
    "@keyframes uploadBrandsProgress": {
      from: { transform: "translateX(-100%)" },
      to: { transform: "translateX(350%)" },
    },
  },
};

export default styles;
